/**
 * File: src/services/admin-auth-service.js
 * Mô tả: Dịch vụ quản lý phiên xác thực Admin (Auth Service), gửi request kiểm tra tài khoản phía Server.
 * Liên quan: functions/api/admin/login.js, src/components/admin-login-modal.js, src/pages/admin-page.js
 */

const SESSION_STORAGE_KEY = 'snt_admin_session_auth';

/**
 * Kiểm tra xem người dùng đã đăng nhập Admin hợp lệ chưa
 * @returns {boolean}
 */
export const isAdminAuthenticated = () => {
  try {
    const sessionStr = sessionStorage.getItem(SESSION_STORAGE_KEY) || localStorage.getItem(SESSION_STORAGE_KEY);
    if (!sessionStr) return false;
    const data = JSON.parse(sessionStr);
    return Boolean(data && data.token && data.username);
  } catch (e) {
    return false;
  }
};

/**
 * Lấy thông tin phiên làm việc hiện tại
 * @returns {Object|null}
 */
export const getAdminSession = () => {
  try {
    const sessionStr = sessionStorage.getItem(SESSION_STORAGE_KEY) || localStorage.getItem(SESSION_STORAGE_KEY);
    return sessionStr ? JSON.parse(sessionStr) : null;
  } catch (e) {
    return null;
  }
};

/**
 * Gửi yêu cầu đăng nhập Admin tới Cloudflare Pages Function API
 * @param {string} username 
 * @param {string} password 
 * @param {boolean} [rememberMe=false] 
 * @returns {Promise<{ success: boolean, message: string }>}
 */
export const loginAdmin = async (username, password, rememberMe = false) => {
  try {
    const res = await fetch('/api/admin/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    if (res.ok) {
      const data = await res.json();
      if (data.success) {
        const sessionData = { username: data.username, token: data.token, loggedInAt: new Date().toISOString() };
        if (rememberMe) {
          localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
        } else {
          sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
        }
        return { success: true, message: data.message || 'Đăng nhập thành công!' };
      }
    } else if (res.status === 401) {
      return { success: false, message: 'Mật khẩu hoặc tài khoản Admin không chính xác!' };
    }
  } catch (e) {
    console.warn('Chưa kết nối Cloudflare Pages Function API (Đang chạy Local Vite dev):', e);
  }

  // Fallback kiểm tra trong môi trường Local Dev nếu không có kết nối Server API
  if (username === 'admin' && password === 'sntgames@2026') {
    const sessionData = { username: 'admin', token: `local_dev_${Date.now()}`, loggedInAt: new Date().toISOString() };
    if (rememberMe) {
      localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
    } else {
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sessionData));
    }
    return { success: true, message: 'Đăng nhập Admin (Local Dev Mode) thành công!' };
  }

  return { success: false, message: 'Tài khoản hoặc mật khẩu không đúng!' };
};

/**
 * Đăng xuất khỏi phiên làm việc Admin
 */
export const logoutAdmin = () => {
  sessionStorage.removeItem(SESSION_STORAGE_KEY);
  localStorage.removeItem(SESSION_STORAGE_KEY);
};
